import { largeIconStyles, mediumIconStyles, smallIconStyles, largeIconBorderRadius, mediumIconBorderRadius, smallIconBorderRadius, mediumIndeterminateStyles } from './styles.js';

var CHECK_SIZE_CLASSES = {
  large: largeIconStyles,
  medium: mediumIconStyles,
  small: smallIconStyles
};
var SIZE_BORDER_RADIUS_CLASSES = {
  large: largeIconBorderRadius,
  medium: mediumIconBorderRadius,
  small: smallIconBorderRadius
};
var CHECK_ICON_SIZE_CLASSES = {
  large: 'h-16 w-16',
  medium: 'h-14 w-14',
  small: 'h-12 w-12'
};
var INDETERMINATE_ICON_SIZE_CLASSES = {
  large: 'h-8 w-8',
  medium: mediumIndeterminateStyles,
  small: 'h-6 w-6'
};

export { CHECK_ICON_SIZE_CLASSES, CHECK_SIZE_CLASSES, INDETERMINATE_ICON_SIZE_CLASSES, SIZE_BORDER_RADIUS_CLASSES };
//# sourceMappingURL=index.js.map
